import { render, staticRenderFns } from "./FamilyPane.vue?vue&type=template&id=7a631c0b&scoped=true&"
import script from "./FamilyPane.vue?vue&type=script&lang=js&"
export * from "./FamilyPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a631c0b",
  null
  
)

export default component.exports